//i18n plugin setup
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from "lodash";

//install the plugin
Vue.use(VueI18n);

//set up the current locale and the fallback locale
const process = require('process');
const fallbackLocale = process.env.FALLBACK_LOCALE || 'en';
const locale = _.get(_.first(document.getElementsByTagName('html')), 'lang', fallbackLocale);

//import all supported translations (for now manually :( )
//the "i18n" alias path it was set in the webpack config js
import en from 'i18n/en.json';
import es from 'i18n/es.json';
const messages = {en, es};

//set the options object
const i18nOptions = {
    locale,
    fallbackLocale,
    messages,
};

export const i18n = new VueI18n(i18nOptions);
